export type RefundEvent = {
    event: 'refund';
    ecommerce: {
        transaction_id: string;
    };
};

export const trackRefundEvent = (transactionId: string): RefundEvent => ({
    event: 'refund',
    ecommerce: {
        transaction_id: transactionId
    }
});
